/*

  HEADS UP! THIS IS A GENERATED FILE!

  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { faCheck, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { verify } from 'app/shared/actions/generated/user.actions';
import { ShowWhenContainsOtherThanH5, TextInput } from 'components/inputs';
import {} from 'components/Selects';
import domainModel from 'domain-model';
import Formsy from 'formsy-react';
import _ from 'lodash';
import lodashUUID from 'lodash-uuid';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Col, FormGroup, Label, Row } from 'reactstrap';
_.mixin(lodashUUID);

class VerifyForm extends React.Component {
  static get propTypes() {
    return {
      entity: PropTypes.object.isRequired,
      immutableFields: PropTypes.object,
      onChange: PropTypes.func,
      resetOnSubmit: PropTypes.bool,
      onSubmit: PropTypes.func,
      translateError: PropTypes.func,
      transformParamsPreSubmit: PropTypes.func,
      className: PropTypes.string,
      mutateEntityOnChange: PropTypes.func,
      submitButtonText: PropTypes.string,
      color: PropTypes.string,
      readonly: PropTypes.bool,
      disabled: PropTypes.bool,
      modal: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      immutableFields: {},
      submitButtonText: 'Spara',
      resetOnSubmit: false,
      transformParamsPreSubmit: params => params,
      onChange: () => {},
      color: undefined,
      className: '',
      readonly: false,
      disabled: false,
      modal: false,
      mutateEntityOnChange: entity => entity,
      onSubmit: () => {},
      translateError: err => {
        if (_.get(err, 'response.status') === 409) {
          const uniqueErrors = err.response.data.data.filter(
            error => error.path !== 'owningSupplierOrganizationId',
          );

          const result = uniqueErrors
            .map(
              uniqueError =>
                `${domainModel.getTranslation(
                  'user',
                  uniqueError.path,
                )} finns redan och måste vara unikt`,
            )
            .join('\n');
          return result;
        }
        if (_.get(err, 'response.status') === 422) {
          const validationErrors = err.response.data.data;
          const result = validationErrors.map(validation => validation.message);
          return result.join('\n');
        }
        return _.get(err, 'response.data.message', JSON.stringify(err));
      },
    };
  }

  static defaultActionValues() {
    return {
      token: '',
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return {
      submitting: false,
      errorMessage: JSON.stringify({
        message: error.message,
        stack: error.stack,
      }),
    };
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setFormToValid = this.setFormToValid.bind(this);
    this.setFormToInvalid = this.setFormToInvalid.bind(this);
    this.createMergedEntity = this.createMergedEntity.bind(this);
    this.update = this.update.bind(this);

    this.state = {
      entity: this.createMergedEntity(),
      formIsValid: true,
    };
  }

  componentDidUpdate(prevProps) {
    const { entity } = this.props;
    if (entity !== prevProps.entity) {
      // eslint-disable-next-line
      this.setState({ entity: this.createMergedEntity() });
    }
  }

  handleOnClick(event) {
    event.stopPropagation();
    if (event.detail !== 1) {
      return;
    }
    this.handleSubmit(event);
  }

  async handleSubmit(event) {
    event.stopPropagation();

    const {
      immutableFields,
      onSubmit,
      resetOnSubmit,
      transformParamsPreSubmit,
      translateError,
    } = this.props;
    const { entity } = this.state;

    await this.setState({
      submitting: true,
      errorMessage: undefined,
      submitResult: null,
    });

    let submitParams = entity;
    if (transformParamsPreSubmit && _.isFunction(transformParamsPreSubmit)) {
      submitParams = transformParamsPreSubmit(entity);
    }

    let result = null;

    try {
      const response = await verify(submitParams);
      result = response.data;
    } catch (err) {
      await this.setState({
        submitting: false,
        errorMessage: translateError(err),
        submitResult: 'error',
      });
      return;
    }

    if (resetOnSubmit) {
      this.form && this.form.reset();
      await this.update({
        ...VerifyForm.defaultActionValues(),
        ...immutableFields,
      });
    }
    try {
      await onSubmit(submitParams, result);
    } catch (err) {
      /* eslint-disable-next-line no-console */
      console.error(err);
    }
    await this.setState({
      submitting: false,
      submitResult: 'success',
      errorMessage: undefined,
    });
  }

  async handleChange(modifiedKey, value, modifiedChildEntity = undefined) {
    const { entity } = this.state;
    await this.update(
      { ...entity, [modifiedKey]: value },
      modifiedKey,
      modifiedChildEntity,
    );
    await this.setState({
      submitting: false,
      submitResult: null,
      errorMessage: undefined,
    });
  }

  setFormToValid() {
    this.setState({ formIsValid: true });
  }

  setFormToInvalid() {
    this.setState({ formIsValid: false });
  }

  createMergedEntity() {
    const { entity, immutableFields } = this.props;
    return domainModel.user.ensureInvariants({
      ...VerifyForm.defaultActionValues(),
      ...entity,
      ...immutableFields,
    });
  }

  update(entity, modifiedKey, modifiedChildEntity = undefined) {
    const { mutateEntityOnChange, onChange, immutableFields } = this.props;
    const mutatedEntity = mutateEntityOnChange(entity, modifiedChildEntity);
    const ensuredEntity = domainModel.user.ensureInvariants({
      ...mutatedEntity,
      ...immutableFields,
    });
    this.setState({ entity: ensuredEntity });
    onChange(entity, modifiedKey, modifiedChildEntity);
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      props: {
        immutableFields,
        submitButtonText,
        color,
        className,
        readonly,
        disabled,
        sessionUser,
        modal,
      },
      state: { entity, formIsValid, submitting, errorMessage },
    } = this;
    /* eslint-enable */

    return (
      <Formsy
        onValid={this.setFormToValid}
        onInvalid={this.setFormToInvalid}
        ref={c => {
          this.form = c;
        }}
      >
        {/* eslint-disable-next-line */}
        <Row>
          <ShowWhenContainsOtherThanH5>
            {/* eslint-disable-next-line */}
            {typeof immutableFields.token === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label></Label>

                  <TextInput
                    name="token"
                    id={`tokenField-${entity.id}`}
                    value={entity.token}
                    disabled
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}
          </ShowWhenContainsOtherThanH5>
        </Row>
        {errorMessage && (
          <Alert color="danger" style={{ whiteSpace: 'pre-wrap' }}>
            {errorMessage}
          </Alert>
        )}
        {!readonly && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {/* Spinner, check, or cross icon left of button */}
            {submitting && (
              <span className="me-2">
                <FontAwesomeIcon icon={faSpinner} spin color="#888" />
              </span>
            )}
            {!submitting &&
              this.state &&
              this.state.submitResult === 'success' && (
                <span className="me-2">
                  <FontAwesomeIcon icon={faCheck} color="#28a745" />
                </span>
              )}
            {!submitting && this.state && this.state.submitResult === 'error' && (
              <span className="me-2">
                <FontAwesomeIcon icon={faTimes} color="#dc3545" />
              </span>
            )}
            <Button
              id="verifySubmitButton"
              onClick={event => {
                this.handleOnClick(event);
              }}
              className={`float-end d-print-none ${className}`}
              color={color || 'primary'}
              disabled={!formIsValid || submitting || disabled}
            >
              {submitButtonText}
            </Button>
          </div>
        )}
      </Formsy>
    );
  }
}

const mapStateToProps = (
  { authentication: { sessionUser } },
  { onSubmit, immutableFields, entity },
) => ({
  entity,
  sessionUser,
  onSubmit,
  immutableFields,
});

const verifyExport = connect(mapStateToProps, null, null, {
  forwardRef: true,
})(VerifyForm);

// eslint-disable-next-line import/prefer-default-export
export { verifyExport as VerifyForm };
